<div class="row ss-top-menu">
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard </span>
    <span style="vertical-align: -webkit-baseline-middle;"> <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Payments </span>
  </div>
  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5">
    <div class="ss-searchbox">
      <i class="fa fa-search"></i>
      <input class="form-control" type="text" placeholder="Type in name, contact, status, role, date to search..." #search (keyup)="0">
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
        {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div>
</div>


<div class="row body_height justify-content-center">
  <div class="col-12">
    <h5 *ngIf=" projectList && projectList.length == 0 " class="text-center my-5">No payment Available</h5>
    <div class="tableDiv">
      <collapsible-table [type]="'accordion'" bordered class="table" *ngIf="projectList && projectList.length >0">

      <!-- <table class="table" *ngIf="projectList && projectList.length >0"> -->
        <thead class="ss-thead">
          <collapsible-table-row>
            <th class="firstTh" style="min-width: 1rem;">#</th>
            <th style="min-width: 5rem;">Name of Client</th>
            <th style="min-width: 5rem;">Name of Project</th>
            <th style="min-width: 5rem;">Name of Designer</th>
            <th style="min-width: 5rem;">Total BOQ Value</th>
            <th style="min-width: 12rem;">Total Added Payment</th>
            <th class="lastTh" style="min-width: 5rem;">Stage of Payment</th>
          </collapsible-table-row>
        </thead>
        <tbody class="ss-tbody">

        	<ng-container *ngFor="let obj of projectList | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  }; let i = index " [attr.data-index]="i" >
        		<collapsible-table-row [detail]="detail1">
	            <td style="min-width: 1rem;">{{i+1}}</td>
	            <td class="capitalize">
	            	<span *ngIf="obj.project && obj.project.user">{{obj.project.user.name | replaceChar}}</span>
	            </td>
	            <td class="capitalize">
	            	<span *ngIf="obj.project">{{obj.project.name | replaceChar}}</span>
	            </td>
	            <td class="capitalize">
	            	<span *ngIf="obj.project && obj.project.designer">{{obj.project.designer.name}}({{obj.project.designer.email}})</span>
	            </td>
	            <td class="capitalize">{{obj.total_boq_value_of_payment}}</td>
	            <td class="capitalize">{{obj.amount}}</td>
	            <td class="capitalize">{{obj.payment_type | replaceChar}}</td>

	          </collapsible-table-row>
	          <collapsible-table-row-detail #detail1>
	            <table class="table table-bordered">
	              <tr class="table-row">
	                <td scope="col">REF NO.</td>
	                <td scope="col">PAID AMOUNT</td>
	                <td scope="col">TOTAL AMOUNT</td>
	              </tr>
	              <tr *ngFor="let payment of obj.quotation_payments ">
	                <td class="capitalize">{{payment.reference_number}}</td>
	                <td>{{payment.paid_amount}}</td>
	                
	                <td >{{payment.net_amount}}</td>
	                
	              </tr>
	            </table>
	          </collapsible-table-row-detail> 
          </ng-container>
        </tbody>
      </collapsible-table>
    </div>
    <div class="text-center" *ngIf="projectList && projectList.length >0">
        <pagination-controls autoHide="true" (pageChange)="current_page = nextPage($event)"></pagination-controls>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-payment/cm-payment.component.html